<template>
  <div class="gift relative bg_contain">
    <div class="gift_main flex_a_c">
      <div
        class="gift_icon bg_contain"
        :class="{ default_gift_icon: !icon }"
        :style="{
          backgroundImage: `url(${icon || defaultIcon})`
        }"
      ></div>
      <div class="gift_ctx flex_1 ml_15">
        <div class="gift_name fs_12 mb_3">{{ name }}</div>
        <div class="gift_desc fs_12 scale08_bot van-multi-ellipsis--l2">{{ desc }}</div>
      </div>
      <template v-if="copy === false">
        <button
          v-if="!hideBtn"
          class="gift_btn"
          :class="{
            btn_disabled: disabled,
            btn_receivable: btnText === '待领取'
          }"
          :style="{
            backgroundColor: btnColor
          }"
          @click="handleReceive"
        >{{ btnText }}</button>
      </template>
      <template v-else>
        <button
          v-clipboard="copy"
          class="gift_btn"
          :style="{
            backgroundColor: btnColor
          }"
          @click="$emit('copyCb')"
        >
          复制
        </button>
      </template>
      <div class="gift_tag">
        {{ tag }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: '**礼包'
    },
    desc: {
      type: String,
      default: '待配置',
    },
    btnText: {
      type: String,
      default: '领取'
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    hideBtn: {
      type: Boolean,
      default: false,
    },
    btnColor: {
      type: String,
      default: ''
    },
    // 复制内容
    copy: {
      type: [String, Boolean],
      default: false,
    },
    tag: {
      type: String,
      default: ''
    },
  },
  data () {
    return {
      defaultIcon: 'https://static.hzwxbz3.cn/Lianyun/font_end/heziIOS/gift1.png'
    }
  },
  methods: {
    handleReceive () {
      if (!this.disabled) {
        this.$emit('receive')
      } else {
        this.$emit('disableClick')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.gift_tag {
  position: absolute;
  top: -11px;
  right: 1px;
  background-color: #EB2F9D;
  color: #fff;
  line-height: 1;
  padding: 4px 8px 3px 22px;
  font-size: 14px;
  font-weight: 700;
  border-radius: 100px;
  &::after {
    content: '返';
    position: absolute;
    left: 10px;
    bottom: 4px;
    font-size: 12px;
    transform: scale(0.8);
    transform-origin: 0% 50%;
  }
  &::before {
    content: '';
    position: absolute;
    right: 0;
    bottom: -7px;
    width: 0;
    height: 0;
    border-top: 4px solid;
    border-right: 15px solid;
    border-left: 15px solid;
    border-bottom: 11px solid;
    border-color: transparent #EB2F9D transparent transparent;
  }
}
.gift {
  padding: 8px 12px;
  border-radius: 6px;
  background-image: url('../../assets/payAmount/giftBg.png');
}
.gift_icon {
  width: 60px;
  height: 60px;
}
.gift_ctx {
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: left;
  min-width: 0; // 神秘魔法，这一行不能删
}
.gift_name {
  font-weight: 700;
}
.gift_desc {
  width: 125%;
  color: #fff;
  line-height: 1.25;
  padding-right: 6px;
}
.gift_btn {
  font-size: 12px;
  min-width: 70px;
  box-sizing: border-box;
  height: 36px;
  font-weight: bolder;
  text-align: center;
  padding: 4px 12px;
  line-height: 1.2;
  background-color: #FFD242;
  color: #78170E;
  // color: transparent;
  border-radius: 1000px;
  border: none;
  // transform: translateY(6px);
  white-space: pre-wrap;
  // -webkit-text-stroke: .3px #B2480E; 
  // -webkit-text-fill-color: transparent;
}
.gift_btn.btn_disabled {
  color: white;
}
.btn_receivable {
  position: relative;
  &::after {
    content: "";
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: #EB2E2E;
    position: absolute;
    top: -1px;
    right: 4px;
  }
}
.default_gift_icon {
  padding: 9px;
  border-radius: 15px;
  background-color: #fef3f1;
  background-size: 64%;
  background-position: center;
}
</style>